module.exports = __webpack_public_path__ + "assets/_card-1.65114cc5.svg";